import React, { useCallback, useEffect, useRef, useState, useContext } from "react";
import { createTheme } from '@mui/material/styles';
import {
  makeStyles,
  ThemeProvider,
} from "@mui/styles";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { unstable_useTreeItem2 as useTreeItem2 } from '@mui/x-tree-view/useTreeItem2';
import {
  TreeItem2Content,
  TreeItem2IconContainer,
  TreeItem2GroupTransition,
  TreeItem2Root,
} from '@mui/x-tree-view/TreeItem2';
import { useTreeViewApiRef } from '@mui/x-tree-view/hooks/useTreeViewApiRef';
import { TreeItem2Icon } from '@mui/x-tree-view/TreeItem2Icon';
import { TreeItem2Provider } from '@mui/x-tree-view/TreeItem2Provider';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { PublicOutlined } from "@mui/icons-material";
import AdvancedSearchContext from "context/AdvancedSearchContext";

import { ReactComponent as BatimentArbre } from "assets/img/tree/black/Batiment-arbre.svg";
import { ReactComponent as CommuneArbre } from "assets/img/tree/black/Commune-arbre.svg";
import { ReactComponent as EntiteArbre } from "assets/img/tree/black/Entité-arbre.svg";
import { ReactComponent as FeuArbre } from "assets/img/tree/black/Feu-arbre.svg";
import { ReactComponent as GroupeArbre } from "assets/img/tree/black/Groupe-arbre.svg";
import { ReactComponent as SiteArbre } from "assets/img/tree/black/Site-arbre.svg";
import { ReactComponent as ZoneArbre } from "assets/img/tree/black/Zone-arbre.svg";
import { ReactComponent as CompteArbre } from "assets/img/tree/black/Compte-arbre.svg";

import { styled } from '@mui/material/styles';
import clsx from 'clsx';

const darkTheme = createTheme({
  palette: {
    type: "dark",
    text: {
      primary: "#363636",
    },
  },
});

const useTreeItemStyles = makeStyles((theme) => ({
  root: {
    marginTop: "5px",
    color: 'var(--tree-view-uneselected-color)',
    '&:hover > $content': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '&:focus > $content, &$selected > $content': {
      backgroundColor: '#FFFFFF',
      color: 'var(--tree-view-color)',
    },
    '&$selected > $content': {
      backgroundColor: '#FFFFFF',
      color: 'var(--tree-view-color)',
    },

  },
  content: {
    color: 'var(--tree-view-uneselected-color)',
    //borderTopRightRadius: '16px',
    //borderBottomRightRadius: '16px',
    paddingRight: '8px',
    fontWeight: 500,
    '$expanded > &': {
      fontWeight: 400,
    },
  },
  group: {
    marginLeft: '6px',
    //'& $content': {
    //    paddingLeft: '16px',
    //},
  },
  expanded: {},
  selected: {
    '&:focus > $content, &$selected > $content': {
      backgroundColor: "#FFFFFF",
      color: '#fafafa',
    },
    '&$selected > $content': {
      backgroundColor: "#91C73C",
      color: '#fafafa',
    },
  },
  label: {
    fontWeight: 'bold',
    backgroundColor: "transparent !important",
    paddingLeft: '0px'
  },
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: '0px 0px 0px 0px',
  },
  labelIcon: {
    marginRight: '6px',
    color: '#000000',
    fontSize: '1.1rem',
    width: '15px',
    height: '15px'
  },
  labelText: {
    fontWeight: 'normal',
    fontFamily: '"Source Sans Pro",sans-serif',
    flexGrow: 1,
    fontSize: '0.83rem',
    paddingTop: '4px'
  },
}));



const useStyles = makeStyles({
  root: {
    height: 264,
    flexGrow: 1,
    maxWidth: 400,
  },
});




function EmbeddedEntitesTree(props) {
  const apiRef = useTreeViewApiRef();
  const appContext = useContext(AdvancedSearchContext);
  const classes = useStyles();
  const [treeView, setTreeView] = useState([]);
  const [onSelectIds, setOnSelectIds] = useState(props.userSelectedIds);
  const [expanded, setExpanded] = useState([]);
  const [initialNodeIds, setInitialNodeIds] = useState([]);
  const [architecture, setArchitecture] = useState([]);
  const { embeddedtreerefresh, setEmbeddedtreerefresh } = appContext;
  const [init, setInit] = useState(true);

  useEffect(() => {
    console.log(init,embeddedtreerefresh);
    if (init || embeddedtreerefresh) {
      let architecturetmp = appContext.architecture;
      if (props.filterfromnode) {
        let newarchi = filterTree(architecturetmp, props.filterfromnode);
        architecturetmp = newarchi;
      }
      setArchitecture(architecturetmp)
      let treeviewtmp = getTreeView(architecturetmp);
      let fulltreeview = [];
      let leaf = {};
      leaf.label = "Mes entités"
      leaf.id = "0";
      leaf.avobid = "0";
      leaf.labelIcon = getTreeIcon(0, 2);

      if (treeviewtmp && treeviewtmp.length > 0)
        leaf.children = treeviewtmp;
      fulltreeview.push(leaf);

      setTreeView(fulltreeview);

      let initialNodeIdstmp = [];
      for (let i = 0; i < architecturetmp.length; i++) {
        initialNodeIdstmp.push(architecturetmp[i].id);
      }
      setInitialNodeIds(initialNodeIdstmp);
      if (props.userSelectedIds && props.userSelectedIds.length > 0) {
        let expandedtmp = ["0"];
        defineExpanded(treeviewtmp, expandedtmp);
        setExpanded(expandedtmp);
      }
      setInit(false);
      setEmbeddedtreerefresh(false);
    }
  }, [embeddedtreerefresh]);


  const filterTree = (archi, idsearched) => {
    let archisearched = [];
    for (var i = 0; i < archi.length; i++) {
      // console.log('Searching on '+archi[i].id);
      if (archi[i].id === idsearched) {
        let obj = { ...archi[i] };
        archisearched.push(obj);
      }
      else if (archi[i].children && archi[i].children.length > 0) {
        archisearched = filterTree(archi[i].children, idsearched);
      }
      if (archisearched && archisearched.length > 0)
        break;
    }
    return archisearched;
  }

  const getTreeView = (archiData) => {
    return archiData.map((archiElement) => {
      let leaf = {};
      leaf.label = archiElement.text;
      leaf.id = "" + archiElement.id;
      leaf.avobid = archiElement.id;
      leaf.inactive = false;
      leaf.labelIcon = getTreeIcon(archiElement.type, archiElement.subtype);
      if (archiElement.children && archiElement.children.length > 0) {
        let leafchilds = getTreeView(archiElement.children);
        if (leafchilds.length > 0)
          leaf.children = leafchilds;
      }
      return leaf;
    });
  }

  const getTreeIcon = (type, subtype) => {
    let icon = GroupeArbre;
    if (type == 0) {
      if (subtype == 0)
        icon = CommuneArbre;
      else if (subtype == 1)
        icon = EntiteArbre;
      else if (subtype == 2)
        icon = GroupeArbre;
      else
        icon = GroupeArbre;
    }
    else if (type == 1) {
      icon = SiteArbre;
    }
    else if (type == 2) {
      if (subtype == 0)
        icon = BatimentArbre;
      else if (subtype == 1)
        icon = FeuArbre;
      else
        icon = BatimentArbre;
    }
    else if (type == 3) {
      icon = ZoneArbre;
    }
    else if (type == 4) {
      icon = CompteArbre;
    }
    return icon;
  }

  const defineExpanded = (treenode, expandednodes) => {
    let expandfather = false;
    treenode.forEach((item) => {
      let expanded = false;
      if (onSelectIds.includes(item.id)) {
        expanded = true;
      }
      let expandedbychildren = false;
      if (item.children && item.children.length > 0)
        expandedbychildren = defineExpanded(item.children, expandednodes);
      if (expandedbychildren)
        expandednodes.push(item.id);
      if (expanded || expandedbychildren)
        expandfather = true;
    });
    return expandfather;
  }


  const StyledTreeItemRoot = styled(TreeItem2Root)(({ theme }) => ({
    // marginTop: "5px !important",
    paddingTop: 4,
    [`& .MuiCollapse-root`]: {
      paddingLeft: 5,
      marginLeft: 0,
    },
    color: "var(--tree-view-uneselected-color)",
    "&:hover > $content": {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    "&:focus > $content, &$selected > $content": {
      backgroundColor: "#636363",
      color: "var(--tree-view-color)",
    },
    "&$selected > $content": {
      backgroundColor: "#636363",
      color: "var(--tree-view-color)",
    },
  }));
  const CustomTreeItemContent = styled(TreeItem2Content)(({ theme }) => ({
    color: "var(--tree-view-uneselected-color)",
    paddingRight: '8px',
    paddingLeft: 0,
    paddingTop: 0,
    paddingBottom: 0,
    columnGap: 3,
    fontWeight: 500,
    "$expanded > &": {
      fontWeight: 400,
    },
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },
    [`&.AVOB-searched`]: {
      color: "#91c241"
    },
    [`&.Mui-selected`]: {
      backgroundColor: "#91C73C",
      color: "#FFFFFF"
    }
  }));



  const CustomTreeItem = React.forwardRef(function CustomTreeItem(props, ref) {
    const classesTreeItem = useTreeItemStyles();
    const classes = useStyles();
    const { id, itemId, label, disabled, children, ...other } = props;
    const {
      getRootProps,
      getContentProps,
      getIconContainerProps,
      getLabelProps,
      getGroupTransitionProps,
      status,
      publicAPI,
    } = useTreeItem2({ id, itemId, children, label, disabled, rootRef: ref });

    let item = publicAPI.getItem(itemId);
    let LabelIcon = item.labelIcon;

    return (
      <TreeItem2Provider itemId={itemId}>
        <StyledTreeItemRoot {...getRootProps(other)}>
          <CustomTreeItemContent {...getContentProps({
            className: clsx('content', {
              'Mui-expanded': status.expanded,
              'Mui-selected': status.selected,
              'Mui-focused': status.focused,
              'Mui-disabled': status.disabled,
            }),
          })}>
            <TreeItem2IconContainer {...getIconContainerProps()} className="avobtreeicon">
              <TreeItem2Icon status={status} />
            </TreeItem2IconContainer>
            <div className={classesTreeItem.labelRoot}>
              <LabelIcon color="inherit" className={classesTreeItem.labelIcon} />
              <Typography variant="body2" className={classesTreeItem.labelText}>
                {label}
              </Typography>
            </div>
          </CustomTreeItemContent>
          {children && (
            <TreeItem2GroupTransition {...getGroupTransitionProps()} />
          )}
        </StyledTreeItemRoot>
      </TreeItem2Provider >
    );
  });

  let fulltreeview = [];
  let leaf = {};
  leaf.label = "Mes entités"
  leaf.id = "item0";
  leaf.avobid = "0";
  leaf.labelIcon = getTreeIcon(0, 2);
  fulltreeview.push(leaf);

  return (
    <div>
      <ThemeProvider theme={darkTheme}>
        {
          treeView.length > 0 ?
            <RichTreeView
              apiRef={apiRef}
              id={"embededtreeview"}
              className={classes.root}
              slots={{
                item: CustomTreeItem,
                expandIcon: ArrowRightIcon,
                collapseIcon: ArrowDropDownIcon,
                // endIcon: <div style={{ width: 50 }} />,
                parentIcon: PublicOutlined
              }}
              items={treeView}
              defaultExpandedItems={props.userSelectedIds}
              expandedItems={expanded}
              multiSelect={props.multiSelect}
              selectedItems={onSelectIds}
              onSelectedItemsChange={(event, ids) => {
                event.persist();
                const iconClicked = event.target
                  .closest('div')
                  .matches('[class*="avobtreeicon"]');
                if (!iconClicked) {
                  if (ids) {
                    if (!props.multiSelect && props.cantSelectZero && ids === '0') {

                    }
                    else {
                      setOnSelectIds(ids);
                      props.selectedIds(ids);
                    }
                  }
                }
              }}
              onExpandedItemsChange={(event, itemIds) => {
                event.persist();
                const iconClicked = event.target
                  .closest('div')
                  .matches('[class*="avobtreeicon"]');
                if (iconClicked) {
                  setExpanded(itemIds);
                }
              }}
            >

            </RichTreeView>
            : <></>
        }

      </ThemeProvider>
    </div>
  );

}

export default EmbeddedEntitesTree;

EmbeddedEntitesTree.defaultProps = {
  multiSelect: false,
  cantSelectZero: false,
};

EmbeddedEntitesTree.propTypes = {
  architecture: PropTypes.arrayOf(PropTypes.object),
};
